import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PageSection } from "@/components/AppLayout.jsx";
import { DemoNotice } from "@/components/DemoNotice.jsx";
import { usePublicCopy } from "@/i18n/karatePublicI18n.js";
import { usePageMeta } from "@/hooks/usePageMeta.js";

export function PrivacyPolicyPage() {
  const { copy, locale } = usePublicCopy();
  const p = copy.privacy;
  usePageMeta(
    {
      titleFr: "Politique de confidentialité — Shotokan AAMC",
      titleEn: "Privacy Policy — Shotokan AAMC",
      descriptionFr: p.metaDescription,
      descriptionEn: p.metaDescriptionEn,
    },
    locale,
  );

  return (
    <PageSection title={p.title} subtitle={p.subtitle} testId="page-confidentialite">
      <DemoNotice variant="card" />
      <div className="prose prose--wide" data-testid="privacy-policy-content">
        {p.sections.map((section) => (
          <section key={section.id} className="privacy-section">
            <h2>{section.heading}</h2>
            <ul>
              {section.bullets.map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>
          </section>
        ))}
        <p className="muted">{p.footerNote}</p>
        <p>
          <Link to="/contact" data-testid="privacy-link-contact">
            {p.contactLink}
          </Link>
        </p>
      </div>
    </PageSection>
  );
}

export function ContactPage() {
  const { copy, locale } = usePublicCopy();
  const c = copy.contact;
  const [simulated, setSimulated] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  usePageMeta(
    {
      titleFr: "Contact — Shotokan AAMC",
      titleEn: "Contact — Shotokan AAMC",
      descriptionFr: c.metaDescription,
      descriptionEn: c.metaDescriptionEn,
    },
    locale,
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    setSimulated(true);
  };

  return (
    <PageSection title={c.title} subtitle={c.subtitle} testId="page-contact">
      <DemoNotice variant="card" />
      <div className="prose prose--wide">
        <p>{c.intro}</p>
        <p>
          <strong>{c.emailLabel}</strong>{" "}
          <span data-testid="contact-demo-email">{c.demoEmail}</span>
        </p>
        <p className="muted">{c.phase1Note}</p>

        <form className="contact-form-mock" onSubmit={handleSubmit} data-testid="contact-form-mock">
          <p className="info-box">
            <strong>[{locale === "en" ? "DEMO" : "DÉMO"}]</strong> {c.formNotice}
          </p>
          <label>
            {c.nameLabel}
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
              data-testid="contact-name"
            />
          </label>
          <label>
            {c.emailFieldLabel}
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              data-testid="contact-email"
            />
          </label>
          <label>
            {c.messageLabel}
            <textarea
              rows={4}
              value={form.message}
              onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))}
              data-testid="contact-message"
            />
          </label>
          <button type="submit" className="btn-primary" data-testid="contact-submit">
            {c.submitLabel}
          </button>
        </form>

        {simulated ? (
          <p className="import-message" role="status" data-testid="contact-simulation-message">
            {c.simulationMessage}
          </p>
        ) : null}

        <p>
          <Link to="/demande-compte" data-testid="contact-link-account-request">
            {c.accountRequestLink}
          </Link>
          {" · "}
          <Link to="/confidentialite" data-testid="contact-link-privacy">
            {c.privacyLink}
          </Link>
        </p>
      </div>
    </PageSection>
  );
}
